<template>
    <div class="sidebar-detail__section">
        <div class="sidebar__section sidebar__section--border-top-huge sidebar__section--larger-top-vertical-padding">
            <span class="copy-light-small">Verkehrsmeldungen</span>
        </div>
        <POIResultsItem v-for="(message, index) in trafficMessages" :poi="message" :key="index" />
    </div>
</template>

<script>
import POIResultsItem from '@/components/POIResultsItem.vue'
import { getBasicPreparedPoiData } from '@/utils/poi-utils'


export default {
    components: {
        POIResultsItem
    },
    props: {
        poi: {
            type: Object,
            default: () => {}
        },
    },
    computed: {
        trafficMessages() {
            const messages = []
            this.poi.trafficMessages.forEach(message => {
                const preparedMessage = getBasicPreparedPoiData('traffic', message)
                messages.push(preparedMessage)
            })
            return messages
        },
        parentPoi() {
            return {
                id: this.poi.id,
                type: this.poi.type,
                subType: this.poi.subType,
                showingMapPins: false,
            }
        }
    },
    mounted() {
        if(this.parentPoi) {
            this.$store.commit('setPreviousActivePoi', this.parentPoi)
        }
    },
}
</script>